var map = {
	"./auto.png": "0561",
	"./home.png": "fbf5",
	"./industrial.png": "f8f4",
	"./logo.png": "cf05",
	"./logo2.png": "5fbe",
	"./logo3.png": "d092",
	"./logo4.png": "5c9d",
	"./other.png": "f092",
	"./yard.png": "f04f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";